import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { TableFeature, useTiersInfo } from '@mc/plans-ui'
import { FREE_TRIAL_I18N_NAMESPACE, i18nInstance } from '../../../i18n'
import { useFreeTrial } from '../../../lib'

const PricingFeatureComponent = () => {
  const { t } = useTranslation(FREE_TRIAL_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()

  return (
    <TableFeature.Feature>
      <TableFeature.Label
        title={t('common.checkout.plans.features.pricing.title')}
      />
      <TableFeature.Individual>
        <PricingCell product={individual} />
      </TableFeature.Individual>
      <TableFeature.Duo>
        <PricingCell product={duo} />
      </TableFeature.Duo>
      <TableFeature.Family>
        <PricingCell product={family} />
      </TableFeature.Family>
    </TableFeature.Feature>
  )
}

const PricingCell = ({
  product: { displayMonthlyPrice },
}: {
  product: {
    displayMonthlyPrice: string
  }
}) => {
  const { t } = useTranslation(FREE_TRIAL_I18N_NAMESPACE)
  const { trial } = useFreeTrial()

  return (
    <>
      <span
        aria-label={t('common.checkout.plans.features.pricing.cell.price', {
          price: displayMonthlyPrice,
        })}
      >
        {displayMonthlyPrice}
      </span>
      <p className='mc-text--success mc-text--center mc-text-small mc-text--bold mc-pt-1'>
        {t('common.checkout.plans.features.pricing.cell.copy', {
          duration: trial.strings.durationShort,
        })}
      </p>
    </>
  )
}

export const PricingFeature = withI18nContext(i18nInstance)(
  PricingFeatureComponent,
)
